<script setup>
// import { Clipboard } from '@/utils'
import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue'
import Clipboard from 'clipboard'
import SwiperCore, { A11y, Navigation, Pagination } from "swiper"
import "swiper/components/navigation/navigation.scss"
import "swiper/components/pagination/pagination.scss"
import "swiper/swiper.scss"
import { Swiper, SwiperSlide } from "swiper/vue"
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import CalendarMobile from '../assets/img/clendar_mobile.png'
import Closet2 from '../assets/img/closet2.png'
import Closet2Mobile from '../assets/img/closet2_mobile.png'
import ClosetBackground from '../assets/img/closet_background.png'
import ClosetBackground2 from '../assets/img/closet_background2.png'
import ClosetFooterMobile from '../assets/img/closet_footer_mobile.png'
import ClosetFooterPC from '../assets/img/closet_footer_pc.png'
import Discount from '../assets/img/discount.png'
import IconFB from '../assets/img/icon_fb.png'
import IconShare from '../assets/img/icon_share.png'
import Leave1 from '../assets/img/leave1.png'
import Leave2 from '../assets/img/leave2.png'
import Shopback from '../assets/img/shopback.png'
import CircularProgress from '../components/CircularProgress.vue'
import Collapse from '../components/Collapse.vue'
import Loading from '../components/Loading.vue'
import { useClosetStore } from '../stores/closet'
import { useDeviceStore } from '../stores/device'

const MARQUEE_IMG_ARRAY = ['唐鳳', '末羊子', '阿卡貝拉', '張景嵐', '晏柔中', '雷艾美', '謝雨芝', '夏宇童', '安以喬', '洪淇', '文雨非', '李懿', '仔仔', '開水小姐', '愛甯', '楊小黎', '艾比華華', '姜冪','思語紅', 'Philena', '孟耿如', '連俞涵', '吳姍儒', '展榮展瑞', '董仔', '眾量級', '壹加壹', '黃氏兄弟', '方馨', '梁以辰']
const clotheColumn = ['上架時間', '衣服名稱', '實際售價', '售出時間', '回饋金']
SwiperCore.use([Navigation, Pagination, A11y]);

const DeviceStore = useDeviceStore()
const ClosetStore = useClosetStore()
const ShopbackCalculateREF = ref()
const ShopbackUseREF = ref()
const FAQREF = ref()
const scrollToTarget = targetREF => {
  targetREF.scrollIntoView({behavior: 'smooth'})
}

const route = useRoute()
const router = useRouter()
const end = ref(false)
onMounted(async () => {
  if (route.params.email) {
    const result = await ClosetStore.queryOwner(route.params.email)
    console.log(route)
    if (result.state === 'NOT_FOUND') {
      ClosetStore.changeFromHomeState(false)
      router.replace('/')
      alert('查詢不到的此 Email 的會員帳號，請確認 Email 是否正確')
    }
  }

  setTimeout(() => {
    end.value = true
  }, 7200)
})

const fillToThreeImg = clotheList => {
  if (clotheList.length < 5) {
    switch (clotheList.length) {
      case 1: return Array(5).fill(clotheList[0])
      case 2: return [...clotheList, ...clotheList, clotheList[0]]
      default: return [...clotheList, ...clotheList.slice(0, 5 - clotheList.length)]
    }
  }
  return clotheList
}

new Clipboard(".share-button");
const copyToClipBoard = async (text, message) => {
  try {
    // await toClipboard(text)
    // Clipboard.copy(text)
    alert(message)
  } catch (e) {
    console.error(e)
  }
}
const shareClick = async (link, message) => {
  await ClosetStore.recordShareClick()
  copyToClipBoard(`和我一起加入百位藝人的永續時尚浪潮！\n這是我在二拾衫的專屬線上衣櫥，快來逛逛吧 >>\n${link}\n\n透過衣櫥內的專屬優惠代碼，訂單可以現折200元！\n除此之外，加入會員後，每邀請1位好友完成首筆訂單再得購衣金 200元，購衣金獎勵無上限，讓我們掀起永續時尚新潮流！`, message)
}
</script>

<template>
  <Transition>
    <Loading v-if="!end && ClosetStore.fromHome"></Loading>
  </Transition>

  <div class="view-closet" v-if="ClosetStore.owner">
    <section v-if="ClosetStore.fromHome" class="dashboard" :style="`background-image: url(${ClosetBackground});`">
      <div class="left">
        <h2>Hello, {{ ClosetStore.owner['姓名'] }}</h2>
        <p>歡迎來到循環時尚衣<span class="font-noto">櫥</span>！</p>
      </div>
      <div class="right">
        <CircularProgress :r="DeviceStore.currentMode === 'MOBILE' ? 45 : 100" :value="parseInt(ClosetStore.owner['售出件數']) / parseInt(ClosetStore.owner['上架件數']) * 100" :max="100" size="thin">
          <p>{{ ClosetStore.owner['售出比例'] }}<br>找到新家</p>
        </CircularProgress>
        <CircularProgress :r="DeviceStore.currentMode === 'MOBILE' ? 45 : 100" :value="parseInt(ClosetStore.owner['水資源']) / parseInt(ClosetStore.owner['總水資源']) * 100" :max="100" size="thin">
        <p>{{ ClosetStore.owner['水資源'] }}瓶<br>節省水資源<br>(寶特瓶)</p>
        </CircularProgress>
        <CircularProgress :r="DeviceStore.currentMode === 'MOBILE' ? 45 : 100" :value="parseInt(ClosetStore.owner['碳排放']) / parseInt(ClosetStore.owner['總碳排放']) * 100" :max="100" size="thin">
        <p>{{ ClosetStore.owner['碳排放'] }}磅<br>減少碳排放</p>
        </CircularProgress>
      </div>
    </section>
    <section class="table-wrapper">
      <div class="table-scroll">
        <table v-if="ClosetStore.fromHome">
          <thead>
            <tr>
              <th v-for="column in clotheColumn" :key="column">
                {{ column }}
              </th>
            </tr>
          </thead>
          
          <tbody>
            <tr v-for="row in ClosetStore.closetList" :key="row['編號']">
              <td v-for="(column) in clotheColumn" :key="`${row['編號']}_${column}`">{{ row[column] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
    
    <main>
      <header>
        <img :src="Leave1" alt="">
        <span>
          <h2>將{{ ClosetStore.owner['姓名'] }}的拾尚 共享給世界！</h2>
          <p>2022年, 100*100*100人的永續穿搭, 在二拾衫一起發掘無盡的綠色可能</p>
        </span>
        <img :src="Leave2" alt="">
      </header>

      <section class="itmes-carousel">
        <header>
          <LeftOutlined />
          <RightOutlined />
        </header>
        <Swiper :slidesPerView="DeviceStore.currentMode === 'COMPUTER' ? 5 : 3" :spaceBetween="50" :loop="true" :pagination="{ clickable: true }">
          <swiper-slide v-for="row in fillToThreeImg(ClosetStore.closetList)" :key="`clothe_pic_${row['編號']}`">
            <a :href="row['照片連到官網']" target="_blank">
              <img v-if="row['顯示在收衣系統的照片']" :src="row['顯示在收衣系統的照片']" alt="">
              <div v-else class="no-clothe-pic">
                {{ ClosetStore.owner['未上架資訊'] }}
              </div>
            </a>
            <p>{{ row['衣服名稱'] }}</p>
          </swiper-slide>
        </Swiper>
      </section>

      <div class="image-marquee">
          <header :style="{ backgroundImage: `url(${ClosetBackground2})` }">
            <h2>和超過<span>100+</span>藝人網紅，一同捲起永續拾尚潮流!</h2>
          </header>

          <Vue3Marquee :duration="30">
            <div class="marquee-item" v-for="(marqueImgName, index) in MARQUEE_IMG_ARRAY" :key="`marque_img_${index}`">
              <img  :src="require(`../assets/img/marquee/${index+1}.webp`)" alt="">
              <p>{{ marqueImgName }}</p>
            </div>
          </Vue3Marquee>
        </div>

      <span class="discount">
        <img :src="Discount" alt="">
        <a href="https://www.twentythree.com.tw/" target="_blank">Click</a>
        <p>推薦代碼：{{ ClosetStore.owner['優惠代碼'] }}</p>
      </span>
      <div class="info">
        <!-- <p class="i1">循環時尚這件酷事情, 分享給{{ ClosetStore.owner['姓名'] }}的好友♡</p>   -->
      
        <button
          class="share-button"
          :data-clipboard-text="`和我一起加入百位藝人的永續時尚浪潮！\n這是我在二拾衫的專屬線上衣櫥，快來逛逛吧 >>\nhttps://twentythreesearch.web.app/closet/${ClosetStore.owner['email']}\n\n透過衣櫥內的專屬優惠代碼，訂單可以現折200元！\n除此之外，加入會員後，每邀請1位好友完成首筆訂單再得購衣金 200元，購衣金獎勵無上限，讓我們掀起永續時尚新潮流！`"
          @click="shareClick(`https://twentythreesearch.web.app/closet/${ClosetStore.owner['email']}`, '連結已複製,將衣櫥分享給好友吧!')"
        >
          <img :src="IconShare" alt="">
          <p>分享這個衣<span class="font-noto">櫥</span></p>
        </button>

        

        <section class="from-home-only" v-if="ClosetStore.fromHome">
          <h3>分享你的線上衣<span class="font-noto">櫥</span>,  賺現金回饋！</h3>
          <span>
            <i>1</i>
            當您的朋友透過「{{ ClosetStore.owner['優惠代碼'] }}」下單,  您可以獲得訂單金額的<p>5%</p>作為<p>現金回饋</p>
          </span>

          <span>
            <i>2</i>
            點擊<a href="https://kol.shoplineapp.com" target="_blank"> https://kol.shoplineapp.com </a><span class="font-noto">查</span>詢透過「{{ ClosetStore.owner['優惠代碼'] }}」成立之訂單 <br v-if="DeviceStore.currentMode === 'COMPUTER'"> (初次使用需使用官網會員 email 註冊)
          </span>

          <span>*活動時間1個月，現金回饋將於活動結束「當月月底」匯至您的會員帳戶，若需提領請私訊客服</span>

          <img class="closet-img-2" :src="DeviceStore.currentMode === 'COMPUTER' ? Closet2 : Closet2Mobile" alt="">

          <nav :style="{backgroundImage: `url(${ClosetBackground2})`}">
            <ul>
              <li @click="scrollToTarget(ShopbackCalculateREF)">
                <h3>回饋金計算方式</h3>
                <p>more >></p>
              </li>
              <li @click="scrollToTarget(ShopbackUseREF)">
                <h3>回饋金使用方式</h3>
                <p>more >></p>
              </li>
              <li @click="scrollToTarget(FAQREF)">
                <h3>FAQ常見問題</h3>
                <p>more >></p>
              </li>
            </ul>
          </nav>

          <div class="calendar" ref="ShopbackCalculateREF">
            <img v-if="DeviceStore.currentMode == 'COMPUTER'" :src="Shopback" alt="">
            <!-- <img v-if="DeviceStore.currentMode == 'COMPUTER'" :src="Calendar" alt=""> -->
            <img v-else class="calendar-mobile" :src="CalendarMobile" alt="">
          </div>

          <footer>
            <img ref="ShopbackUseREF" :src="DeviceStore.currentMode === 'COMPUTER' ? ClosetFooterPC : ClosetFooterMobile" alt="">
            <div class="faq" ref="FAQREF">
              <p class="faq-title">F<br>A<br>Q</p>
              <Collapse title="有看到衣服在官網上售出，回饋金欄位卻沒有更新？">
                為了提高您的衣物售出機率，讓消費者安心購買，我們目前有提供30天無條件退貨，因此實際售價、售出時間、回饋金欄位將於衣物售出隔月月底更新喔！屆時也會再以email通知您！
              </Collapse>
              <Collapse>
              <template #title>
                <span class="font-noto">查</span>詢平台內顯示衣物有上架，卻未在官網顯示？
              </template>
                若有查詢到衣物上架記錄，卻未在官網顯示，表示該件衣物已售出哦！
              </Collapse>
              <Collapse>
              <template #title>
                有收到衣物上架的email，但<span class="font-noto">查</span>詢平台卻顯示<span class="font-noto">查</span>無資料？
              </template>
                因系統與第三方平台合作，剛上架時會有些微延遲的情況，一個工作天內系統即會正常顯示！
              </Collapse>
              <Collapse title="是否可以等全部衣服販售時間結束，再一次將回饋金額提領至個人帳戶？">
                可以的！回饋金等同於您的現金，可以先儲存在官網購物金內，待衣物販售時間結束再一次申請帳戶結清！
              </Collapse>
            </div>
            
            <div class="service-info">
              <h6>SERVICE</h6>
              <div>
                <span>
                  有任何疑問歡迎私訊粉專<br>
                  或撥打客服電話<br><br>
                  Tel: 02-25072123（10:00 ~ 20:00 ）
                </span>

                <span>
                  <p>私訊粉專</p>
                  <a href="https://m.me/113940290252039?ref=fq-E6QRMfv" target="_blank">
                    <img :src="IconFB" alt="">
                  </a>
                </span>
              </div>
            </div>
          </footer>
        </section>
      </div>
    </main>
  </div>
</template>

